<section class="home">
  <img src="assets/bannerTransparent.png" width="50%" height="50%" alt="Logo" class="logo">
  <h1>Sell your Cards!</h1>
  <p class="subtitle">
    Please read the <a class="instructions-link" routerLink="/how-it-works">instructions</a> carefully and fill out the submission form below to get started.
  </p>

  <form (ngSubmit)="submit()" class="form">
    <div class="field">
      <label for="name">Name</label>
      <input
        id="name"
        type="text"
        [(ngModel)]="name"
        name="name"
        placeholder="Your Name"
        required
      />
    </div>

    <div class="field">
      <label for="email">E-Mail</label>
      <input
        id="email"
        type="email"
        [(ngModel)]="email"
        name="email"
        placeholder="name@email.com"
        required
      />
    </div>

    <div class="field">
      <label for="file">File</label>
      <input
        id="file"
        type="file"
        (change)="onFileSelected($event)"
      />
    </div>

    <button type="submit" [disabled]="isSubmitting">
      {{ isSubmitting ? 'Sending…' : 'Submit' }}
    </button>

    <p class="msg success" *ngIf="successMsg">{{ successMsg }}</p>
    <p class="msg error" *ngIf="errorMsg">{{ errorMsg }}</p>
  </form>
</section>
